export default __webpack_public_path__ + "static/media/IMG_9907.c6ad6bf1.jpg";